module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-48x48-80141a5ecfa6fd4e1e6a9fa5f0bf3a4a.png";